import { RiskIncidentSidePanelController } from '../controller/RiskIncidentSidePanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class RiskIncidentSidePanelWebComponent extends BaseWebComponentElement {
  public controller: RiskIncidentSidePanelController;
  public type = '1';

  constructor(public incidentId: string, public companyId: string, public typeOfSectionFocused: string = '') {
    super();
    this.initialSetup({
      controllerConstructor: RiskIncidentSidePanelController,
    });
    this.incidentId = incidentId;
    this.companyId = companyId;
    this.typeOfSectionFocused = typeOfSectionFocused;
  }
}
